export default {
    primary: {
        main: "#ff9800",
        light: "#ffa726",
        contrastText: "#fff"
    }
}